import { Component, Input } from '@angular/core';

@Component({
  selector: 'section-title',
  templateUrl: 'section-title.component.html',
  styleUrls: ['section-title.component.css']
})
export class SectionTitleComponent {

  @Input() icon!: string;
  @Input() text!: string;
  @Input() size!: number;

  constructor() { }
}
